import request from './service/index';
export function translateLibrary_Api(keyword) {//查询列表
    return request({
        url: `CMS/tools/translate_library?keyword=${keyword}`,
        method: 'get',
    });
}

export function createTranslateLibrary_Api(data) {
    return request({
        url: 'CMS/tools/translate_library',
        method: 'post',
        data: data
    });
}

export function deleteTranslateLibrary_Api(data) {
    return request({
        url: 'CMS/tools/translate_library',
        method: 'delete',
        data: data
    });
}

export function stopWordLibrary_Api(keyword) {//查询列表
    return request({
        url: `CMS/tools/stop_word_library?keyword=${keyword}`,
        method: 'get',

    });
}

export function createStopWordLibrary_Api(data) {
    return request({
        url: 'CMS/tools/stop_word_library',
        method: 'post',
        data: data
    });
}

export function deleteStopWordLibrary_Api(data) {
    return request({
        url: 'CMS/tools/stop_word_library',
        method: 'delete',
        data: data
    });
}

// export function deleteStopWordLibrary_Api(data) {
//     return request({
//         url: 'CMS/tools/stop_word_library',
//         method: 'delete',
//         data: data
//     });
// }


// WEBPACK FOOTER //
// ./src/apis/word.api.js